

















































































































































































































































































import { CONST_YN, Pagination, YN } from '@/common';
import { Component, Vue } from 'vue-property-decorator';
import { ArticleDto, ArticleListDto } from '@/dto';
import { component } from 'vue/types/umd';
import ArticleService from '../../../services/article.service';
import BaseComponent from '@/core/base.component';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';

import toast from '../../../../resources/assets/js/services/toast.js';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';

@Component({
  name: 'ArticleList',
})
export default class ArticleList extends BaseComponent {
  private articleList: ArticleDto[] = [];
  private articleListCount = null;
  private articleSearchDto = new ArticleListDto();
  private pagination = new Pagination();
  private dataLoading = false;
  private showYn: YN[] = [...CONST_YN];

  private articleCreateDto = new ArticleDto();
  private articleImage: FileAttachmentDto[] = [];

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.articleSearchDto, this.pagination);
    }
    ArticleService.findAll(this.articleSearchDto, this.pagination).subscribe(
      res => {
        if (res) {
          this.dataLoading = false;
          this.articleList = res.data.items;
          this.articleListCount = res.data.totalCount;
        }
      },
    );
  }

  search() {
    this.findAll(true, true);
  }

  paginateSearch() {
    this.findAll(true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.articleSearchDto = new ArticleListDto();
      this.findAll();
    }
  }

  createArticle() {
    this.articleCreateDto.image = this.articleImage;
    ArticleService.create(this.articleCreateDto).subscribe(res => {
      if (res) {
        toast.success('추가완료');
        this.clearOut();
      }
    });
  }

  // upload article image
  async upload(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(UPLOAD_TYPE.ARTICLE, [
        file,
      ]);
      this.articleImage = [];
      this.articleImage.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
    }
  }

  clearOutArticleCreateDto() {
    this.articleImage = [];
    this.articleCreateDto = new ArticleDto();
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.articleSearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
  }
}
